import { SELECT, DESELECT, SELECT_ALL, DESELECT_ALL, TABLE_DATA, PAGE_SIZE, TABLE_DATA2 } from "./actionTypes";


export const select = () => ({
    type: SELECT
})

export const deSelect = () => ({
    type: DESELECT
})
export const selectAll = (num) => ({
    type: SELECT_ALL,
    payload: num
})

export const deSelectAll = () => ({
    type: DESELECT_ALL
})

export const pageSize = () => ({
    type: PAGE_SIZE
})

export const tableData = (obj) => ({
    type: TABLE_DATA,
    payload: obj
})

export const tableData2 = (page) => ({
    type: TABLE_DATA2,
    payload: page
})



